// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.assessment.AssessmentAutoDiagnosisResponse */
/* istanbul ignore next */
@GandalfModel
export class AssessmentAutoDiagnosisResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	code!: string | null;

	@GandalfConstantDecorator(constants.CodeSet)
	@GandalfProperty({ designType: constants.CodeSet })
	codeSet!: constants.CodeSet | null;

	@GandalfConstantDecorator(constants.DiagnosisLocation)
	@GandalfProperty({ designType: constants.DiagnosisLocation })
	diagnosisLocation!: constants.DiagnosisLocation | null;

	@GandalfProperty({ designType: Number })
	encounterAutoDiagnosisId!: number | null;

	@GandalfProperty({ designType: String })
	longDescription!: string | null;

	@GandalfProperty({ designType: Number })
	masterDiagnosis!: number | null;

	@GandalfProperty({ designType: Number })
	personDiagnosisId!: number | null;

	@GandalfProperty({ designType: Number })
	practiceDiagnosisId!: number | null;

	@GandalfProperty({ designType: String })
	shortDescription!: string | null;

	@GandalfConstantDecorator(constants.EncounterAutoDiagnosisStatus)
	@GandalfProperty({ designType: constants.EncounterAutoDiagnosisStatus })
	status!: constants.EncounterAutoDiagnosisStatus | null;

}
